<template>
    <emc-table-icon 
        :color="color"
        :icon="icon"
        :disabled="disabled"
        :loading="loading"
        :tool-tip="toolTip"
        @click="$emit('click')"
    />
</template>
<script>
export default {
    name: "EmcTableIconDelete",
    data () {
        return {
            
        }
    },
    props: {
        color: {
            type: String,
            default: "error"
        },
        icon: {
            type: String,
            default: "mdi-delete-outline"
        },
        toolTip: {
            type: String,
            default: "Excluir"
        },
        disabled: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        },
    },
}
</script>
